import { INTEGRATIONS_CONFIG } from "./catalog";

export function normalizeIntegrationValue(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

function getIntegrationLookupCandidates(value) {
  const rawValue = String(value || "").trim();
  const normalizedValue = normalizeIntegrationValue(rawValue);
  const candidates = [normalizedValue];

  const baseTitle = rawValue.split(/\s+-\s+/)[0]?.trim();
  const normalizedBaseTitle = normalizeIntegrationValue(baseTitle);

  if (normalizedBaseTitle && normalizedBaseTitle !== normalizedValue) {
    candidates.push(normalizedBaseTitle);
  }

  return candidates.filter(Boolean);
}

const INTEGRATION_KEY_ALIASES = {
  controllrisp: "controllr",
  controllr: "controllr",
  hubsoft: "hubsoft",
  sgp: "sgp",
  elitesoft: "elitesoft",
  sienge: "sienge",
  ixcsoft: "ixc",
  ixc: "ixc",
  bemobi7az: "bemobi",
  bemobi: "bemobi",
  "7az": "bemobi",
  duobox: "duobox",
  duo: "duobox",
  mksolutions: "mksolutions",
  atlaz: "atlaz",
  atlas: "atlaz",
  efi: "efi",
  voalle: "voalle",
  cobrefacil: "cobrefacil",
  asaas: "asaas",
  receitanet: "receitanet",
  ispfy: "ispfy",
  lhisp: "lhisp",
  superlogicaassinaturas: "superlogica",
  superlogica: "superlogica",
  ssotica: "ssotica",
  sotica: "ssotica",
  tsunamileaf: "tsunami",
  tsunami: "tsunami",
  leaf: "tsunami",
  f5erp: "f5erp",
  f5: "f5erp",
  mkauth: "mkauth",
  mikweb: "mikweb",
  cora: "cora",
  omie: "omie",
};

export function resolveIntegrationKey(value) {
  const normalizedCandidates = getIntegrationLookupCandidates(value);
  if (normalizedCandidates.length === 0) return null;

  const directConfig = INTEGRATIONS_CONFIG.find((integration) =>
    [integration.id, integration.key, integration.title]
      .filter(Boolean)
      .some((candidate) =>
        normalizedCandidates.includes(normalizeIntegrationValue(candidate)),
      ),
  );

  if (directConfig?.key) return directConfig.key;
  if (directConfig?.title) {
    return INTEGRATION_KEY_ALIASES[normalizeIntegrationValue(directConfig.title)] || null;
  }

  return (
    normalizedCandidates
      .map((candidate) => INTEGRATION_KEY_ALIASES[candidate])
      .find(Boolean) || null
  );
}

export function resolveIntegrationConfig(value) {
  const key = resolveIntegrationKey(value);
  if (!key) return null;

  return (
    INTEGRATIONS_CONFIG.find(
      (integration) =>
        integration.key === key ||
        normalizeIntegrationValue(integration.title) === key,
    ) || null
  );
}

export function resolveIntegrationTitle(value) {
  return resolveIntegrationConfig(value)?.title || value;
}

export function resolveIntegrationIcon(value) {
  return resolveIntegrationConfig(value)?.icon || null;
}
